(async () => {
  if (!customElements.get('product-card-swiper')) {
    const { default: Swiper, A11y, Navigation, Pagination } = await import('swiper');

    Swiper.use([A11y, Navigation, Pagination]);

    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.createSwiper();
      }

      createSwiper() {
        this.swiperElement = this.querySelector('[data-product-card-swiper]');

        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          threshold: 10,
          loop: true,
          autoplay: false,
          navigation: {
            nextEl: '.product-card-image-next',
            prevEl: '.product-card-image-prev',
          },
          pagination: {
            el: '.product-card-image-pagination',
            clickable: true,
          },
          slidesPerView: 1,
          direction: 'horizontal',
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = parseJson(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

      handleSwiperButtons() {
        let windowWidth = window.innerWidth;
        if (windowWidth < 768) {
          this.querySelectorAll('button').forEach((button) => button.classList.remove('hidden'));
        } else if (this.swiperInstance) {
          this.querySelectorAll('button').forEach((button) => button.classList.add('hidden'));
        }
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('product-card-swiper', ProductCard);
  }
})();
